import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GlobalSearchService {
  private readonly searchTermSubject = new BehaviorSubject<string>('');
  readonly searchTerm$: Observable<string> = this.searchTermSubject.asObservable();

  setSearchTerm(term: string): void {
    this.searchTermSubject.next((term || '').trim());
  }

  getSearchTerm(): string {
    return this.searchTermSubject.getValue();
  }
}


